export default __webpack_public_path__ + "static/media/GQ.64304a87.ico";